import { EntityTypes, SchedulerRecordType, SchedulerEventType, Gender, TreatmentType } from 'src/app/core/enums';
import moment from 'moment';
import { TreatmentEntity } from '../interfaces/treatment-entity';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../utils';
import { ConfirmeAppointmentTypes} from '../enums';
import { AssociatedCustomerModel } from './associated-customer-model';

export class AppointmentModel {
    public Title:string;
    public Description: string;
    public Start: moment.Moment;
    public End: moment.Moment;
    public StartTimezone:string;
    public EndTimezone: string;
    public RecurrenceRule: string;
    public RecurrenceException: string;
   

    public EndTime:string;
    public EventType: SchedulerEventType;
    public EventID:number;
    
    public EntityID?: number;
    public EntityName:string;
    public EntityType: EntityTypes;
    public Age: string;
    public Email: string;
    public Mobile: string;
    public Gender: Gender;
    public IsConfidential: boolean;
    public IDNumber: string;

    public Date: moment.Moment;
    public RecurrenceID?:number;
    public RecordType: SchedulerRecordType;
    public SchedulerID:number;
    public PrevSchedulerID:number;
    public SchedulerRoomID:number;
    public PractiseID?: number;
    public PrevRoomID:number;
    public BranchID:number;
    public SchedulerWaitListID?:number;
    
    public BranchName:string;
    public BusinessID:number;
    public LabelColor: string; // the color to show in the scheduler
    public LabelColorID?: number;
    public PriceListCode: string;
    public PriceListRefID: number;    
    public Paid: boolean;
    public Arrived:boolean;
    public Confirmed: ConfirmeAppointmentTypes;
    public ConfirmedByEmailOrSmsOn?: Date;
    public NoShow:boolean;
    public ScdHolidayID: number;
    public ScdName: string;
    public ScdColor:string;
    public Duration:number;

    public Hours:string;
    public Minutes: string;

   
    public CancelReasonID: number;
    public CancelReason: string;
    public Price:string;
    public NotifyBySms: boolean;
    public NotifyByEmail:boolean;
    public NotifyByWhatsApp:boolean;
    // public EntityData: {
    //     Age: string;
    //     Gender: string;
    //     Phone: string;
    //     Email: string
    // };
    public TreatmentType: TreatmentType;
    public TreatmentsFromCard: string;
    public TreatmentsFromPriceList: string; // stringify string of priceListRefID array
    public Treatments?: TreatmentEntity[];
    public AlsoDeleteTreatmentsFromCard: Boolean;
    public IsPaidStatusDirty: Boolean;
    public AssociatedCustomers: AssociatedCustomerModel[];

    constructor(obj?:any){
        
        this.Title = obj && obj.Title || null; // when the first operand is true AND return the second operand
        this.Description = obj && obj.Description || null;
        
        if(obj && obj.Start){
            // fix amazon local date converted to utc twice
           // console.log('Start: ' + obj.Start)
            obj.Start =  obj.Start.replace('+00:00',''); 
            if(obj && obj.End){
                obj.End =  obj.End.replace('+00:00','');
            }
        }

        this.Start = obj && moment(obj.Start) || moment();
        this.End = obj && moment(obj.End) || moment();
        this.StartTimezone = obj && obj.StartTimezone || null;
        
        this.EndTime = obj && obj.EndTime || null;
        this.EndTimezone = obj && obj.EndTimezone || null;
        this.RecurrenceRule = obj && obj.RecurrenceRule || null;
        this.RecurrenceException = obj && obj.RecurrenceException || null;
        this.EventType = obj && obj.EventType || SchedulerEventType.Appointment;
        this.EventID = obj && obj.EventID || 0;
       
        this.EntityID = obj && obj.EntityID || null;
        this.EntityName = obj && obj.EntityName || null;
        this.EntityType = obj && obj.EntityType || EntityTypes.Undefined;
        this.IDNumber = obj && obj.IDNumber || 0;
        this.Gender = obj && obj.Gender || Gender.NotSet;
        this.IsConfidential = obj && obj.IsConfidential || false;
        this.Age = obj && obj.Age || '';
        this.Email = obj && obj.Email || '';
        this.Mobile = obj && obj.Mobile || '';

        this.Date = obj && moment(obj.Date) || moment();        
        this.RecurrenceID = obj && obj.RecurrenceID || null;
        this.RecordType = obj && obj.RecordType || SchedulerRecordType.User;

        this.SchedulerID = obj && obj.SchedulerID || 0;
        this.PrevSchedulerID = obj && obj.PrevSchedulerID || 0;
        this.SchedulerRoomID = obj && obj.SchedulerRoomID || 0;
        this.PractiseID = obj && obj.PractiseID || 0;
        this.PrevRoomID = obj && obj.PrevRoomID || 0;
        this.BranchID = obj && obj.BranchID || 0;
        this.SchedulerWaitListID = obj && obj.SchedulerWaitListID || 0;
        
        this.BranchName = obj && obj.BranchName || null;
        this.BusinessID = obj && obj.BusinessID || 0;
        this.LabelColor = obj && obj.LabelColor || 0;
        this.PriceListCode = obj && obj.PriceListCode || null;
        this.PriceListRefID = obj && obj.PriceListRefID || null;
       

        this.Paid = obj && obj.Paid || false;
        this.Arrived = obj && obj.Arrived || false;
        this.Confirmed = obj && obj.Confirmed || ConfirmeAppointmentTypes.None;
        this.ConfirmedByEmailOrSmsOn = obj && obj.ConfirmedByEmailOrSmsOn || null;
        this.NoShow = obj && obj.NoShow || false;
        this.ScdHolidayID = obj && obj.ScdHolidayID || 0;

        this.ScdName = obj && obj.ScdName || null;
        this.ScdColor = obj && obj.ScdColor || null;
        this.Duration = obj && obj.Duration || 30;
        this.Hours = obj && obj.Hours || 30;
        this.Minutes = obj && obj.Minutes || 30;

        

        this.CancelReasonID = obj && obj.CancelReasonID || null;
        this.CancelReason = obj && obj.CancelReason || null;
        this.Price = obj && obj.Price || 0;
        this.NotifyBySms = obj && obj.NotifyBySms || false;
        this.NotifyByEmail = obj && obj.NotifyByEmail || false;
        this.NotifyByWhatsApp = obj && obj.NotifyByWhatsApp || false;

        this.LabelColorID = obj && obj.LabelColorID || null;        
        //this.EntityData = obj && obj.EntityData || { Age:0, Gender: '', Phone: '', Email: ''};       
        
        this.TreatmentType = obj && obj.TreatmentType || TreatmentType.Treatment;
        this.TreatmentsFromCard = obj && obj.TreatmentsFromCard || null;
        this.TreatmentsFromPriceList = obj && obj.TreatmentsFromPriceList || null;
        this.Treatments = obj && obj.Treatments || null;

        this.AlsoDeleteTreatmentsFromCard = obj && obj.AlsoDeleteTreatmentsFromCard || false;
        this.AssociatedCustomers = obj && obj.AssociatedCustomers || [];
        // console.log(JSON.parse(obj && obj.TreatmentsFromCard || null));
    }


    public getEntityData(){
        return {
          EntityID: this.EntityID,
          EntityType: this.EntityType,
          EntityName: this.EntityName || this.Title,
          Age: this.Age,
          Email: this.Email,
          Gender: this.Gender,
          IsConfidential: this.IsConfidential,
          Mobile: this.Mobile
        };
    }

    // get visitReasonSummary():string{
    //     return Utils.generateVisitReasonSummary1(this.Treatments, this.translate);
    // }
}



